module.exports = __webpack_public_path__ + "img/780cd65.png";